import React, { useEffect, useState } from "react";
import { Speaker } from "../../types/speaker";
import "../../styles/SpeakerModal.scss";

interface SpeakerModalProps {
  speaker: Speaker;
  onClose: () => void;
}

export default function SpeakerModal({ speaker, onClose }: SpeakerModalProps) {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  if (!speaker) return null;

  const handleClose = () => {
    setIsClosing(true);

    // wait for exit animation before closing
    setTimeout(() => {
      onClose();
    }, 700);
  };

  return (
    <div
      className={`speaker-modal-overlay ${isClosing ? "closing" : ""}`}
      onClick={handleClose}
    >
      <div
        className="speaker-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-left-box">
          <img src={speaker.image} alt={speaker.name} />
        </div>

        <div className="modal-right">
          <div className="modal-box mod-red">
            <button className="modal-back" onClick={handleClose}>
              Back to speakers
            </button>
          </div>

          <div className="modal-box mod-pink">
            <h1 className="modal-name">{speaker.name}</h1>
          </div>

          <div className="modal-box mod-green">
            <p className="modal-description">{speaker.description}</p>
          </div>

          <div className="modal-box mod-purple modal-colored-tile" />
        </div>
      </div>
    </div>
  );
}
